import { render, staticRenderFns } from "./pushXiaoMiConfig.vue?vue&type=template&id=4b449f47&scoped=true"
import script from "./pushXiaoMiConfig.vue?vue&type=script&lang=js"
export * from "./pushXiaoMiConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b449f47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b449f47')) {
      api.createRecord('4b449f47', component.options)
    } else {
      api.reload('4b449f47', component.options)
    }
    module.hot.accept("./pushXiaoMiConfig.vue?vue&type=template&id=4b449f47&scoped=true", function () {
      api.rerender('4b449f47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushXiaoMiConfig.vue"
export default component.exports